import { createApp } from '@backstage/frontend-defaults';
import catalogPlugin from '@backstage/plugin-catalog/alpha';
import { navModule } from './modules/nav';
import { createAppPlugin } from './modules/create-app';
import { mumzworldPlugin } from './modules/mumzworld';
import { signInPageModule } from './modules/sign-in';

// catalogPlugin stays installed (reachable at /catalog for internal/admin
// use, see app-config.yaml) but is not in the primary nav and does not own
// the root route — mumzworldPlugin's home page does. createAppPlugin's
// /create-app is kept reachable too (superseded by the 5 kind-specific
// /create/* flows) but not linked from the new sidebar.
export default createApp({
  features: [catalogPlugin, navModule, createAppPlugin, mumzworldPlugin, signInPageModule],
});
